// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, TilingSprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'b11ddb4b-8b28-47ad-a292-65b88fb8a24c',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'b70d2b49-86df-4a9e-9748-f8f6472642b2',
      type: 'Sprite',
      name: 'trackBottom',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1.404612
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Track_Bottom',
      parent: 'b11ddb4b-8b28-47ad-a292-65b88fb8a24c',
      data: {
        dynamicValues: {
          height: 'height - safeHeight + 670'
        }
      }
    },
    {
      id: '446a08e2-d64a-4708-8267-43daf63b5c36',
      type: 'Container',
      name: 'trackHighlightsContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'b11ddb4b-8b28-47ad-a292-65b88fb8a24c'
    },
    {
      id: '999907cb-2dbc-4fa2-997e-21e9e84f3e39',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 32,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Leaderboard_Background',
      parent: 'b11ddb4b-8b28-47ad-a292-65b88fb8a24c'
    },
    {
      id: '7ae42ca9-d7a7-4fee-9f5e-3c112b5816fe',
      type: 'Container',
      name: 'framesContainer',
      className: '',
      x: 0,
      y: -102,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'b11ddb4b-8b28-47ad-a292-65b88fb8a24c'
    },
    {
      id: '8eca8571-3f6c-41c1-9497-b99565dc9433',
      type: 'Sprite',
      name: '',
      className: '',
      x: 401,
      y: 0,
      anchor: {
        x: 0,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'NEW_race_event_track',
      parent: 'b11ddb4b-8b28-47ad-a292-65b88fb8a24c',
      data: {
        DEBUG: true
      }
    },
    {
      id: '5cdf9768-1010-4684-a54a-0eae2083ee6c',
      type: 'Container',
      name: 'topLayoutPart',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'b11ddb4b-8b28-47ad-a292-65b88fb8a24c',
      data: {
        dynamicValues: {
          y: 'safeHeight - height'
        }
      }
    },
    {
      id: '7d1f7196-716b-4467-b543-307b96ceca26',
      type: 'Sprite',
      name: '',
      className: 'trackHighlight',
      x: -270,
      y: -283,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.189655,
        y: 6.922414
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      parent: '446a08e2-d64a-4708-8267-43daf63b5c36'
    },
    {
      id: 'f1c01bbe-8452-4fe4-be9b-dd0c19e9588f',
      type: 'Sprite',
      name: '',
      className: 'trackHighlight',
      x: -135,
      y: -283,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.189655,
        y: 6.922414
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      parent: '446a08e2-d64a-4708-8267-43daf63b5c36'
    },
    {
      id: 'ceadc3ae-f135-4840-beed-15db029da257',
      type: 'Sprite',
      name: '',
      className: 'trackHighlight',
      x: 0,
      y: -283,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.189655,
        y: 6.922414
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      parent: '446a08e2-d64a-4708-8267-43daf63b5c36'
    },
    {
      id: '5642d45f-5ecc-441d-a7ce-bb4ab9b56018',
      type: 'Sprite',
      name: '',
      className: 'trackHighlight',
      x: 135,
      y: -283,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.189655,
        y: 6.922414
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      parent: '446a08e2-d64a-4708-8267-43daf63b5c36'
    },
    {
      id: '5a43e5de-2256-4e3c-9cd8-17278b337f27',
      type: 'Sprite',
      name: '',
      className: 'trackHighlight',
      x: 270,
      y: -283,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.189655,
        y: 6.922414
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      parent: '446a08e2-d64a-4708-8267-43daf63b5c36'
    },
    {
      id: 'd1f3f8d1-6af5-464a-b055-7ccc8cde162d',
      type: 'Container',
      name: '',
      className: 'frameSlot',
      x: -270,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '7ae42ca9-d7a7-4fee-9f5e-3c112b5816fe'
    },
    {
      id: '90d4b7e0-dc99-4c70-90c5-49621d33dbee',
      type: 'Container',
      name: '',
      className: 'frameSlot',
      x: -135,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '7ae42ca9-d7a7-4fee-9f5e-3c112b5816fe'
    },
    {
      id: 'aa3e3677-39b6-431e-acf0-84b46787220d',
      type: 'Container',
      name: '',
      className: 'frameSlot',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '7ae42ca9-d7a7-4fee-9f5e-3c112b5816fe'
    },
    {
      id: 'd8e74343-a615-440c-a7c0-15dfbbf1b785',
      type: 'Container',
      name: '',
      className: 'frameSlot',
      x: 135,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '7ae42ca9-d7a7-4fee-9f5e-3c112b5816fe'
    },
    {
      id: '43a82f6f-4258-4b08-8b95-b5bd4bc57ad1',
      type: 'Container',
      name: '',
      className: 'frameSlot',
      x: 270,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '7ae42ca9-d7a7-4fee-9f5e-3c112b5816fe'
    },
    {
      id: '00f78a6d-54af-49bd-a1be-62c5d4c5297c',
      type: 'Sprite',
      name: '',
      className: 'rotate_SPL',
      x: 3,
      y: -1085,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.5,
        y: 1.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: '5cdf9768-1010-4684-a54a-0eae2083ee6c'
    },
    {
      id: 'f35e6b46-6f39-4889-90ef-bf83056699b7',
      type: 'Sprite',
      name: '',
      className: '',
      x: -4.999999,
      y: -925,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.000001,
        y: 1.000001
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Chests_Podium_Race_Screen',
      parent: '5cdf9768-1010-4684-a54a-0eae2083ee6c'
    },
    {
      id: '30831dc4-4924-497a-bf0e-6b807b76555b',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: -951,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Track_Top',
      parent: '5cdf9768-1010-4684-a54a-0eae2083ee6c'
    },
    {
      id: '9c292e08-85d7-48a8-b048-a15a765be497',
      type: 'Container',
      name: 'carsContainer',
      className: '',
      x: 0,
      y: -829,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5cdf9768-1010-4684-a54a-0eae2083ee6c'
    },
    {
      id: '46301a68-1cef-4b54-9b6f-45c411c5c400',
      type: 'Sprite',
      runtimeType: 'TilingSprite',
      name: '',
      className: 'frameSide,dynamicProps_SPL',
      x: -354,
      y: -655,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 11.290323
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Race_Track_Frame',
      parent: '5cdf9768-1010-4684-a54a-0eae2083ee6c',
      data: {
        dynamicValues: {
          height: 'height - safeHeight + 700'
        }
      }
    },
    {
      id: '6cd9cf51-36bd-462c-b7b5-fe45c9d610b4',
      type: 'Sprite',
      runtimeType: 'TilingSprite',
      name: '',
      className: 'frameSide,dynamicProps_SPL',
      x: 337,
      y: -655,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 11.290323
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Race_Track_Frame',
      parent: '5cdf9768-1010-4684-a54a-0eae2083ee6c',
      data: {
        dynamicValues: {
          height: 'height - safeHeight + 700'
        }
      }
    },
    {
      id: '918c670b-bf19-4adb-8495-a267c4474cb4',
      type: 'Container',
      name: 'lightsContainer',
      className: '',
      x: 0,
      y: -774,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5cdf9768-1010-4684-a54a-0eae2083ee6c'
    },
    {
      id: '3778f100-bedc-4ad3-8f33-5e27f5049334',
      type: 'Container',
      name: 'finishLineContainer',
      className: '',
      x: 0,
      y: -636,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5cdf9768-1010-4684-a54a-0eae2083ee6c'
    },
    {
      id: 'c16c1a55-ba64-42be-8223-5883786fcd96',
      type: 'Container',
      name: 'goalContainer',
      className: '',
      x: 0,
      y: -935,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5cdf9768-1010-4684-a54a-0eae2083ee6c'
    },
    {
      id: '916fb97b-83c1-4785-9c73-827bf0d0da51',
      type: 'Sprite',
      name: 'chestCloseInput',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -2000,
        y: -4000,
        width: 4000,
        height: 4000
      },
      texture: '',
      parent: '5cdf9768-1010-4684-a54a-0eae2083ee6c'
    },
    {
      id: '55f84a9e-1d2e-4d12-82e4-d9381b20ebd0',
      type: 'Container',
      name: 'chestsContainer',
      className: '',
      x: 0,
      y: -1070,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5cdf9768-1010-4684-a54a-0eae2083ee6c'
    },
    {
      id: 'e6720728-30c5-4c5c-9ba8-35f911748925',
      type: 'Container',
      name: 'rankContainer',
      className: '',
      x: 0,
      y: -854,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5cdf9768-1010-4684-a54a-0eae2083ee6c'
    },
    {
      id: '936fa7db-5409-463f-babd-48ce1151422d',
      type: 'Container',
      name: '',
      className: 'carSlot',
      x: -270,
      y: 519,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9c292e08-85d7-48a8-b048-a15a765be497'
    },
    {
      id: '473c68ba-e3ef-4f04-9514-3a7abce69501',
      type: 'Container',
      name: '',
      className: 'carSlot',
      x: -135,
      y: 519,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9c292e08-85d7-48a8-b048-a15a765be497'
    },
    {
      id: '8f5df8c2-1c4c-45eb-99ba-ded9ba4938ef',
      type: 'Container',
      name: '',
      className: 'carSlot',
      x: 0,
      y: 519,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9c292e08-85d7-48a8-b048-a15a765be497'
    },
    {
      id: '72f85b9e-59cb-4ced-a1bb-6eb5c4e6104c',
      type: 'Container',
      name: '',
      className: 'carSlot',
      x: 135,
      y: 519,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9c292e08-85d7-48a8-b048-a15a765be497'
    },
    {
      id: 'eb39e5e4-483a-47c3-bbc2-218cd88bb643',
      type: 'Container',
      name: '',
      className: 'carSlot',
      x: 270,
      y: 519,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9c292e08-85d7-48a8-b048-a15a765be497'
    },
    {
      id: 'c9fc90ef-8138-4b2a-b662-816e48aec632',
      type: 'Container',
      name: 'carFinishedPosition',
      className: '',
      x: 0,
      y: 74,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9c292e08-85d7-48a8-b048-a15a765be497'
    },
    {
      id: '97e4abff-3fee-4821-a832-3727b088aa0f',
      type: 'Container',
      name: 'carPreFinishedPosition',
      className: '',
      x: 0,
      y: 270,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9c292e08-85d7-48a8-b048-a15a765be497'
    },
    {
      id: '746a8e6a-3c17-469d-961d-d0771543b8bf',
      type: 'Container',
      name: 'carStartPosition',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 568,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9c292e08-85d7-48a8-b048-a15a765be497',
      data: {
        dynamicValues: {
          y: 'height - safeHeight + 568'
        }
      }
    },
    {
      id: '95d4dc3f-e077-4469-af4d-12829ad08d06',
      type: 'Container',
      name: 'carPreStartPosition',
      className: '',
      x: 0,
      y: 775,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9c292e08-85d7-48a8-b048-a15a765be497',
      data: {
        dynamicValues: {
          y: 'height - safeHeight + 775'
        }
      }
    },
    {
      id: '10f079ed-c145-49de-ab1f-43deb96511f6',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Finish_Line',
      parent: '3778f100-bedc-4ad3-8f33-5e27f5049334'
    },
    {
      id: 'df3bcd62-c9e5-4879-a12d-7f0483b17d93',
      type: 'Text',
      name: 'finishLineText',
      className: '',
      x: 0,
      y: -21,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level <nr>',
      localize: true,
      maxWidth: 216,
      maxHeight: 101,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#163fbb',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '3778f100-bedc-4ad3-8f33-5e27f5049334'
    },
    {
      id: '78174f6e-7667-4241-97e6-a197c74d7f10',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Goal_Background',
      parent: 'c16c1a55-ba64-42be-8223-5883786fcd96'
    },
    {
      id: 'c3086ea1-4aa7-4189-9087-b94d4ebe0248',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: -49,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Timer_Background',
      parent: 'c16c1a55-ba64-42be-8223-5883786fcd96'
    },
    {
      id: 'dd9347c3-5267-4f0e-9ea5-42777b7b9ca2',
      type: 'Sprite',
      name: '',
      className: '',
      x: -95,
      y: -56,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Golden_Clock',
      parent: 'c16c1a55-ba64-42be-8223-5883786fcd96'
    },
    {
      id: '0051f846-d3f4-41b8-a1ad-914dbfa5916a',
      type: 'Text',
      name: 'timerText',
      className: '',
      x: 0,
      y: -51,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1h 20m',
      localize: false,
      maxWidth: 144,
      maxHeight: 61,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'c16c1a55-ba64-42be-8223-5883786fcd96'
    },
    {
      id: '325f7e59-3d40-470c-8a54-a8f290be9a71',
      type: 'Text',
      name: 'goalText',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Race to Level <nr>!',
      localize: true,
      maxWidth: 436,
      maxHeight: 61,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 34,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#47120a',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#47120a',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'c16c1a55-ba64-42be-8223-5883786fcd96'
    },
    {
      id: 'deb1c01a-eb0b-4c3f-a2e9-0fc723537008',
      type: 'Container',
      name: '',
      className: 'chestSlot',
      x: 0,
      y: 6,
      scale: {
        x: 0.8,
        y: 0.8
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '55f84a9e-1d2e-4d12-82e4-d9381b20ebd0'
    },
    {
      id: '7e0afe67-5b03-4c0a-ad8d-2092ca4b910e',
      type: 'Container',
      name: '',
      className: 'chestSlot',
      x: -181,
      y: 27,
      scale: {
        x: 0.8,
        y: 0.8
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '55f84a9e-1d2e-4d12-82e4-d9381b20ebd0'
    },
    {
      id: '01513781-0f1b-4516-937b-f86ce774e47e',
      type: 'Container',
      name: '',
      className: 'chestSlot',
      x: 169,
      y: 38,
      scale: {
        x: 0.8,
        y: 0.8
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '55f84a9e-1d2e-4d12-82e4-d9381b20ebd0'
    },
    {
      id: '7e846e5a-5fe7-480c-85a4-8cc43c86f60f',
      type: 'Container',
      name: '',
      className: 'rankSlot',
      x: -270,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e6720728-30c5-4c5c-9ba8-35f911748925'
    },
    {
      id: '0c92a921-6d55-404d-9aa3-66944af89a70',
      type: 'Container',
      name: '',
      className: 'rankSlot',
      x: -135,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e6720728-30c5-4c5c-9ba8-35f911748925'
    },
    {
      id: 'ac8f7ce7-058c-4288-ac82-2bbe0f11da97',
      type: 'Container',
      name: '',
      className: 'rankSlot',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e6720728-30c5-4c5c-9ba8-35f911748925'
    },
    {
      id: '8fd6b20b-b2bc-4934-9b9a-d622187b62cd',
      type: 'Container',
      name: '',
      className: 'rankSlot',
      x: 135,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e6720728-30c5-4c5c-9ba8-35f911748925'
    },
    {
      id: 'adcd6ff6-738d-481f-85d7-e3cd050f3fd8',
      type: 'Container',
      name: '',
      className: 'rankSlot',
      x: 270,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e6720728-30c5-4c5c-9ba8-35f911748925'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '2.0.0',
  handleResize: false
} as const;

export class RaceEventTrackLayout {
  static raw = raw;
  root!: Container;
  trackBottom!: Sprite & { data: typeof raw['list'][1]['data'] };
  trackHighlightsContainer!: Container;
  framesContainer!: Container;
  topLayoutPart!: Container & { data: typeof raw['list'][6]['data'] };
  carsContainer!: Container;
  lightsContainer!: Container;
  finishLineContainer!: Container;
  goalContainer!: Container;
  chestCloseInput!: Sprite;
  chestsContainer!: Container;
  rankContainer!: Container;
  carFinishedPosition!: Container;
  carPreFinishedPosition!: Container;
  carStartPosition!: Container & { data: typeof raw['list'][36]['data'] };
  carPreStartPosition!: Container & { data: typeof raw['list'][37]['data'] };
  finishLineText!: Text;
  timerText!: Text;
  goalText!: Text;
  dynamicProps_SPL!: (Sprite & { data: typeof raw['list'][1]['data'] } | Container & { data: typeof raw['list'][6]['data'] } | TilingSprite & { data: typeof raw['list'][21]['data'] } | TilingSprite & { data: typeof raw['list'][22]['data'] } | Container & { data: typeof raw['list'][36]['data'] })[];
  trackHighlight!: (Sprite)[];
  frameSlot!: (Container)[];
  rotate_SPL!: (Sprite)[];
  frameSide!: (TilingSprite & { data: typeof raw['list'][21]['data'] } | TilingSprite & { data: typeof raw['list'][22]['data'] })[];
  carSlot!: (Container)[];
  chestSlot!: (Container)[];
  rankSlot!: (Container)[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
